import classnames from 'classnames'
export default function SvgIcon({
  name = '',
  prefix = 'icon',
  color = '#333',
  className = '',
  ...props
}) {
  const symbolId = `#${prefix}-${name}`

  return (
    <svg
      {...props}
      aria-hidden='true'
      className={classnames('hyb-svg-icon', className, `hyb-svg-icon-${name}`)}
    >
      <use href={symbolId} fill={color} />
    </svg>
  )
}
